// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.goals-display-widget {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.goals-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #dee2e6;
}

.goals-header h3 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.goals-header-controls {
  display: flex;
  gap: 12px;
  align-items: center;
}

.goals-refresh-button {
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  color: #6b7280;
  min-width: 36px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.goals-refresh-button:hover {
  background: #f9fafb;
  border-color: #d1d5db;
  color: #111827;
}

.goals-refresh-button:active {
  transform: scale(0.97);
}

.goals-mode-toggle {
  display: flex;
  gap: 0;
  background: #f3f4f6;
  border-radius: 6px;
  padding: 2px;
}

.goals-mode-toggle button {
  padding: 6px 14px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  height: 32px;
  white-space: nowrap;
  color: #6b7280;
  font-weight: 500;
}

.goals-mode-toggle button:hover {
  background: rgba(255, 255, 255, 0.5);
  color: #111827;
}

.goals-mode-toggle button.active {
  background: white;
  color: #111827;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.year-equity-overview {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.year-equity-header {
  text-align: left;
  margin-bottom: 16px;
}

.year-equity-header h4 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 600;
  color: #333;
}

.year-equity-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 30px;
  flex-wrap: wrap;
}

.equity-info-block {
  text-align: center;
}

.equity-label {
  font-size: 0.85rem;
  color: #6c757d;
  margin-bottom: 8px;
  font-weight: 500;
}

.equity-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

.equity-value.target-equity {
  color: #007bff;
}

.equity-sub-info {
  font-size: 0.75rem;
  color: #6c757d;
  margin-top: 4px;
  font-weight: 500;
}

.equity-arrow {
  font-size: 1.5rem;
  color: #6c757d;
  font-weight: 300;
}

.equity-stat-block {
  text-align: center;
  min-width: 120px;
}

.equity-stat-label {
  font-size: 0.8rem;
  color: #6c757d;
  margin-bottom: 8px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.equity-stat-value {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 4px;
}

.equity-stat-value.positive {
  color: #28a745;
}

.equity-stat-value.negative {
  color: #dc3545;
}

.equity-stat-value.warning {
  color: #ffc107;
}

.equity-stat-percent {
  font-size: 0.9rem;
  font-weight: 500;
  color: #6c757d;
}

.equity-stat-percent.positive {
  color: #28a745;
}

.equity-stat-percent.negative {
  color: #dc3545;
}

.equity-stat-sub {
  font-size: 0.75rem;
  color: #6c757d;
  margin-top: 4px;
}

.goals-cards {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.goal-card {
  flex: 1 1;
  min-width: 200px;
  max-width: 280px;
  background: #ffffff;
  border-radius: 8px;
  padding: 14px; /* Reduced from 20px */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  transition: box-shadow 0.2s ease;
}

.goal-card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Line-by-line structure */
.goal-card-line {
  margin-bottom: 8px; /* Reduced from 12px */
  line-height: 1.4; /* Reduced from 1.5 */
}

.goal-card-line:last-child {
  margin-bottom: 0;
}

/* Line 1: Header - Weekly Goal */
.goal-header-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px; /* Reduced from 16px */
}

.goal-header-text {
  font-size: 0.875rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.loading-indicator {
  color: #9ca3af;
  font-size: 0.75rem;
}

/* Line 2: Amount of the weekly goal */
.goal-amount-line {
  font-size: 1.4rem; /* Reduced from 1.5rem */
  font-weight: 700;
  color: #111827;
  font-variant-numeric: tabular-nums;
  margin-bottom: 10px; /* Reduced from 16px */
}

/* Line 3: The word "Realized" */
.goal-realized-label-line {
  font-size: 0.75rem;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 4px; /* Reduced from 8px */
}

/* Line 4: The realized equity that week */
.goal-realized-value-line {
  font-size: 1.15rem; /* Reduced from 1.25rem */
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  margin-bottom: 10px; /* Reduced from 16px */
}

.goal-realized-value-line.positive {
  color: #10b981;
}

.goal-realized-value-line.negative {
  color: #ef4444;
}

/* Line 5: Progress bar with percentage inside */
.goal-progress-line {
  margin-bottom: 0;
}

.progress-bar-with-text {
  position: relative;
  height: 28px; /* Reduced from 32px */
  background: #f3f4f6;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.progress-bar-fill {
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-width: fit-content;
}

.progress-bar-fill.green {
  background: linear-gradient(90deg, #10b981, #059669);
}

.progress-bar-fill.blue {
  background: linear-gradient(90deg, #3b82f6, #2563eb);
}

.progress-bar-fill.orange {
  background: linear-gradient(90deg, #f59e0b, #d97706);
}

.progress-bar-fill.red {
  background: linear-gradient(90deg, #ef4444, #dc2626);
}

.progress-bar-fill.gray {
  background: #9ca3af;
}

.progress-bar-percentage {
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  font-variant-numeric: tabular-nums;
  padding: 0 8px;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.progress-bar-percentage-empty {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.875rem;
  font-weight: 600;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
  pointer-events: none;
}

/* Yearly Progress Comparison Card Styles */
.yearly-progress-card {
  flex: 1 1;
  min-width: 280px;
  max-width: 350px;
}

.year-progress-section {
  margin-bottom: 16px;
}

.year-progress-section:last-of-type {
  margin-bottom: 12px;
}

.year-progress-label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.year-progress-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
}

.year-progress-value {
  font-size: 0.875rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.year-progress-value.positive {
  color: #10b981;
}

.year-progress-value.neutral {
  color: #3b82f6;
}

.year-progress-value.negative {
  color: #ef4444;
}

.year-progress-value.expected {
  color: #94a3b8;
}

.year-progress-bar-container {
  position: relative;
  width: 100%;
  height: 32px;
  background-color: #f3f4f6;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 4px;
}

.year-progress-bar {
  height: 100%;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 8px;
  transition: width 0.3s ease;
  min-width: 0;
}

.year-progress-bar-actual {
  position: relative;
  z-index: 2;
}

.year-progress-bar-expected {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  opacity: 0.5;
}

.year-progress-bar-text {
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.year-progress-bar-text-outside {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  font-size: 0.75rem;
  font-weight: 500;
  z-index: 3;
}

.year-progress-days-info {
  font-size: 0.75rem;
  color: #9ca3af;
  text-align: right;
}

.year-progress-diff {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px;
  border-radius: 6px;
  margin-top: 8px;
  font-size: 0.875rem;
  font-weight: 600;
}

.year-progress-diff.ahead {
  background-color: #d1fae5;
  color: #065f46;
}

.year-progress-diff.behind {
  background-color: #fee2e2;
  color: #991b1b;
}

.year-progress-diff-icon {
  font-size: 1rem;
}

.year-progress-diff-text {
  font-variant-numeric: tabular-nums;
}

/* Goal label (optional, below progress bar) */
.goal-label-line {
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 8px;
  font-style: italic;
  text-align: center;
}

/* Container for Year Progress and Historical Progress side by side */
.goals-progress-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 2px solid #dee2e6;
}

.year-progress-chart {
  min-width: 0; /* Allow flex shrinking */
}

.year-progress-chart h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 1.2rem;
}

.year-progress-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 20px;
  padding: 15px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.progress-stat {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.progress-stat .label {
  font-size: 0.85rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.progress-stat .value {
  font-size: 1.1rem;
  font-weight: 600;
  color: #212529;
}

.progress-stat .value.positive {
  color: #28a745;
}

.progress-stat .value.negative {
  color: #dc3545;
}

.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  display: inline-block;
  margin-left: 8px;
}

.status-badge.positive {
  background-color: #d4edda;
  color: #155724;
}

.status-badge.negative {
  background-color: #f8d7da;
  color: #721c24;
}

/* Historical Progress Section */
.goals-history-section {
  min-width: 0; /* Allow flex shrinking */
}

.goals-history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.goals-history-header h4 {
  margin: 0;
  color: #333;
  font-size: 1.2rem;
}

.goals-history-controls {
  display: flex;
  gap: 10px;
}

.history-view-select,
.history-periods-select {
  padding: 6px 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: white;
  font-size: 0.9rem;
  cursor: pointer;
}

.goals-history-table-container {
  background: white;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  overflow-x: auto;
}

.goals-history-table {
  width: 100%;
  border-collapse: collapse;
}

.goals-history-table thead {
  background: #f8f9fa;
}

.goals-history-table th {
  padding: 12px 15px;
  text-align: left;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.goals-history-table .history-goal-cell {
  text-align: right;
  font-weight: 500;
  color: #495057;
}

.goals-history-table .history-overunder-cell {
  text-align: right;
  font-weight: 600;
}

.goals-history-table .history-overunder-cell.positive {
  color: #28a745;
}

.goals-history-table .history-overunder-cell.negative {
  color: #dc3545;
}

.goals-history-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #e9ecef;
}

.goals-history-table tbody tr:hover {
  background: #f8f9fa;
}

.history-period-cell {
  font-weight: 500;
  color: #212529;
  min-width: 150px;
}

.history-progress-cell {
  min-width: 200px;
}

.historical-progress-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.historical-progress-bar {
  height: 20px;
  background: #e9ecef;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.historical-progress-fill {
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 10px;
}

.historical-progress-fill.green {
  background: linear-gradient(90deg, #28a745, #20c997);
}

.historical-progress-fill.orange {
  background: linear-gradient(90deg, #ffc107, #fd7e14);
}

.historical-progress-fill.red {
  background: linear-gradient(90deg, #dc3545, #e83e8c);
}

.historical-progress-text {
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
}

.historical-amount {
  color: #212529;
  font-weight: 500;
}

.historical-percentage {
  color: #6c757d;
  font-weight: 600;
}

/* Responsive */
@media (max-width: 1200px) {
  .goals-progress-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .goals-cards {
    flex-direction: column;
  }
  
  .goal-card {
    min-width: 100%;
  }
  
  .yearly-gauge-card {
    max-width: 100%;
  }
  
  .year-progress-info {
    grid-template-columns: 1fr;
  }

  .goals-history-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .goals-history-controls {
    width: 100%;
  }

  .history-view-select,
  .history-periods-select {
    flex: 1 1;
  }

  .goals-progress-container {
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/GoalsDisplay.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa,EAAE,sBAAsB;EACrC,wCAAwC;EACxC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB,EAAE,sBAAsB;EAC1C,gBAAgB,EAAE,qBAAqB;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,iBAAiB,EAAE,wBAAwB;EAC3C,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB,EAAE,yBAAyB;EAC7C,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,sBAAsB;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,cAAc;EACd,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA,2CAA2C;AAC3C;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,YAAY,EAAE,yBAAyB;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,YAAY,EAAE,yBAAyB;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,SAAO;EACT;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".goals-display-widget {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.goals-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.goals-header h3 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.goals-header-controls {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.goals-refresh-button {\n  padding: 6px 10px;\n  border: 1px solid #e5e7eb;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: all 0.2s ease;\n  color: #6b7280;\n  min-width: 36px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.goals-refresh-button:hover {\n  background: #f9fafb;\n  border-color: #d1d5db;\n  color: #111827;\n}\n\n.goals-refresh-button:active {\n  transform: scale(0.97);\n}\n\n.goals-mode-toggle {\n  display: flex;\n  gap: 0;\n  background: #f3f4f6;\n  border-radius: 6px;\n  padding: 2px;\n}\n\n.goals-mode-toggle button {\n  padding: 6px 14px;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: all 0.2s ease;\n  height: 32px;\n  white-space: nowrap;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.goals-mode-toggle button:hover {\n  background: rgba(255, 255, 255, 0.5);\n  color: #111827;\n}\n\n.goals-mode-toggle button.active {\n  background: white;\n  color: #111827;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.year-equity-overview {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e9ecef;\n}\n\n.year-equity-header {\n  text-align: left;\n  margin-bottom: 16px;\n}\n\n.year-equity-header h4 {\n  margin: 0;\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.year-equity-content {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 30px;\n  flex-wrap: wrap;\n}\n\n.equity-info-block {\n  text-align: center;\n}\n\n.equity-label {\n  font-size: 0.85rem;\n  color: #6c757d;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.equity-value {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.equity-value.target-equity {\n  color: #007bff;\n}\n\n.equity-sub-info {\n  font-size: 0.75rem;\n  color: #6c757d;\n  margin-top: 4px;\n  font-weight: 500;\n}\n\n.equity-arrow {\n  font-size: 1.5rem;\n  color: #6c757d;\n  font-weight: 300;\n}\n\n.equity-stat-block {\n  text-align: center;\n  min-width: 120px;\n}\n\n.equity-stat-label {\n  font-size: 0.8rem;\n  color: #6c757d;\n  margin-bottom: 8px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.equity-stat-value {\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.equity-stat-value.positive {\n  color: #28a745;\n}\n\n.equity-stat-value.negative {\n  color: #dc3545;\n}\n\n.equity-stat-value.warning {\n  color: #ffc107;\n}\n\n.equity-stat-percent {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #6c757d;\n}\n\n.equity-stat-percent.positive {\n  color: #28a745;\n}\n\n.equity-stat-percent.negative {\n  color: #dc3545;\n}\n\n.equity-stat-sub {\n  font-size: 0.75rem;\n  color: #6c757d;\n  margin-top: 4px;\n}\n\n.goals-cards {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin-bottom: 30px;\n}\n\n.goal-card {\n  flex: 1;\n  min-width: 200px;\n  max-width: 280px;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 14px; /* Reduced from 20px */\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n  transition: box-shadow 0.2s ease;\n}\n\n.goal-card:hover {\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* Line-by-line structure */\n.goal-card-line {\n  margin-bottom: 8px; /* Reduced from 12px */\n  line-height: 1.4; /* Reduced from 1.5 */\n}\n\n.goal-card-line:last-child {\n  margin-bottom: 0;\n}\n\n/* Line 1: Header - Weekly Goal */\n.goal-header-line {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px; /* Reduced from 16px */\n}\n\n.goal-header-text {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.loading-indicator {\n  color: #9ca3af;\n  font-size: 0.75rem;\n}\n\n/* Line 2: Amount of the weekly goal */\n.goal-amount-line {\n  font-size: 1.4rem; /* Reduced from 1.5rem */\n  font-weight: 700;\n  color: #111827;\n  font-variant-numeric: tabular-nums;\n  margin-bottom: 10px; /* Reduced from 16px */\n}\n\n/* Line 3: The word \"Realized\" */\n.goal-realized-label-line {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 4px; /* Reduced from 8px */\n}\n\n/* Line 4: The realized equity that week */\n.goal-realized-value-line {\n  font-size: 1.15rem; /* Reduced from 1.25rem */\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  margin-bottom: 10px; /* Reduced from 16px */\n}\n\n.goal-realized-value-line.positive {\n  color: #10b981;\n}\n\n.goal-realized-value-line.negative {\n  color: #ef4444;\n}\n\n/* Line 5: Progress bar with percentage inside */\n.goal-progress-line {\n  margin-bottom: 0;\n}\n\n.progress-bar-with-text {\n  position: relative;\n  height: 28px; /* Reduced from 32px */\n  background: #f3f4f6;\n  border-radius: 6px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  transition: width 0.3s ease;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  min-width: fit-content;\n}\n\n.progress-bar-fill.green {\n  background: linear-gradient(90deg, #10b981, #059669);\n}\n\n.progress-bar-fill.blue {\n  background: linear-gradient(90deg, #3b82f6, #2563eb);\n}\n\n.progress-bar-fill.orange {\n  background: linear-gradient(90deg, #f59e0b, #d97706);\n}\n\n.progress-bar-fill.red {\n  background: linear-gradient(90deg, #ef4444, #dc2626);\n}\n\n.progress-bar-fill.gray {\n  background: #9ca3af;\n}\n\n.progress-bar-percentage {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: white;\n  font-variant-numeric: tabular-nums;\n  padding: 0 8px;\n  white-space: nowrap;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.progress-bar-percentage-empty {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #6b7280;\n  font-variant-numeric: tabular-nums;\n  pointer-events: none;\n}\n\n/* Yearly Progress Comparison Card Styles */\n.yearly-progress-card {\n  flex: 1;\n  min-width: 280px;\n  max-width: 350px;\n}\n\n.year-progress-section {\n  margin-bottom: 16px;\n}\n\n.year-progress-section:last-of-type {\n  margin-bottom: 12px;\n}\n\n.year-progress-label-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.year-progress-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.year-progress-value {\n  font-size: 0.875rem;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.year-progress-value.positive {\n  color: #10b981;\n}\n\n.year-progress-value.neutral {\n  color: #3b82f6;\n}\n\n.year-progress-value.negative {\n  color: #ef4444;\n}\n\n.year-progress-value.expected {\n  color: #94a3b8;\n}\n\n.year-progress-bar-container {\n  position: relative;\n  width: 100%;\n  height: 32px;\n  background-color: #f3f4f6;\n  border-radius: 6px;\n  overflow: hidden;\n  margin-bottom: 4px;\n}\n\n.year-progress-bar {\n  height: 100%;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0 8px;\n  transition: width 0.3s ease;\n  min-width: 0;\n}\n\n.year-progress-bar-actual {\n  position: relative;\n  z-index: 2;\n}\n\n.year-progress-bar-expected {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  opacity: 0.5;\n}\n\n.year-progress-bar-text {\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 600;\n  white-space: nowrap;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.year-progress-bar-text-outside {\n  position: absolute;\n  left: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6b7280;\n  font-size: 0.75rem;\n  font-weight: 500;\n  z-index: 3;\n}\n\n.year-progress-days-info {\n  font-size: 0.75rem;\n  color: #9ca3af;\n  text-align: right;\n}\n\n.year-progress-diff {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px;\n  border-radius: 6px;\n  margin-top: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.year-progress-diff.ahead {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.year-progress-diff.behind {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.year-progress-diff-icon {\n  font-size: 1rem;\n}\n\n.year-progress-diff-text {\n  font-variant-numeric: tabular-nums;\n}\n\n/* Goal label (optional, below progress bar) */\n.goal-label-line {\n  font-size: 0.75rem;\n  color: #6b7280;\n  margin-top: 8px;\n  font-style: italic;\n  text-align: center;\n}\n\n/* Container for Year Progress and Historical Progress side by side */\n.goals-progress-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 2px solid #dee2e6;\n}\n\n.year-progress-chart {\n  min-width: 0; /* Allow flex shrinking */\n}\n\n.year-progress-chart h4 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 1.2rem;\n}\n\n.year-progress-info {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n  margin-bottom: 20px;\n  padding: 15px;\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n.progress-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.progress-stat .label {\n  font-size: 0.85rem;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.progress-stat .value {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #212529;\n}\n\n.progress-stat .value.positive {\n  color: #28a745;\n}\n\n.progress-stat .value.negative {\n  color: #dc3545;\n}\n\n.status-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  display: inline-block;\n  margin-left: 8px;\n}\n\n.status-badge.positive {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.status-badge.negative {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n/* Historical Progress Section */\n.goals-history-section {\n  min-width: 0; /* Allow flex shrinking */\n}\n\n.goals-history-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.goals-history-header h4 {\n  margin: 0;\n  color: #333;\n  font-size: 1.2rem;\n}\n\n.goals-history-controls {\n  display: flex;\n  gap: 10px;\n}\n\n.history-view-select,\n.history-periods-select {\n  padding: 6px 12px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: white;\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.goals-history-table-container {\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n  overflow-x: auto;\n}\n\n.goals-history-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.goals-history-table thead {\n  background: #f8f9fa;\n}\n\n.goals-history-table th {\n  padding: 12px 15px;\n  text-align: left;\n  font-weight: 600;\n  color: #495057;\n  border-bottom: 2px solid #dee2e6;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.goals-history-table .history-goal-cell {\n  text-align: right;\n  font-weight: 500;\n  color: #495057;\n}\n\n.goals-history-table .history-overunder-cell {\n  text-align: right;\n  font-weight: 600;\n}\n\n.goals-history-table .history-overunder-cell.positive {\n  color: #28a745;\n}\n\n.goals-history-table .history-overunder-cell.negative {\n  color: #dc3545;\n}\n\n.goals-history-table td {\n  padding: 12px 15px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.goals-history-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.history-period-cell {\n  font-weight: 500;\n  color: #212529;\n  min-width: 150px;\n}\n\n.history-progress-cell {\n  min-width: 200px;\n}\n\n.historical-progress-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.historical-progress-bar {\n  height: 20px;\n  background: #e9ecef;\n  border-radius: 10px;\n  overflow: hidden;\n  position: relative;\n}\n\n.historical-progress-fill {\n  height: 100%;\n  transition: width 0.3s ease;\n  border-radius: 10px;\n}\n\n.historical-progress-fill.green {\n  background: linear-gradient(90deg, #28a745, #20c997);\n}\n\n.historical-progress-fill.orange {\n  background: linear-gradient(90deg, #ffc107, #fd7e14);\n}\n\n.historical-progress-fill.red {\n  background: linear-gradient(90deg, #dc3545, #e83e8c);\n}\n\n.historical-progress-text {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.85rem;\n}\n\n.historical-amount {\n  color: #212529;\n  font-weight: 500;\n}\n\n.historical-percentage {\n  color: #6c757d;\n  font-weight: 600;\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .goals-progress-container {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .goals-cards {\n    flex-direction: column;\n  }\n  \n  .goal-card {\n    min-width: 100%;\n  }\n  \n  .yearly-gauge-card {\n    max-width: 100%;\n  }\n  \n  .year-progress-info {\n    grid-template-columns: 1fr;\n  }\n\n  .goals-history-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .goals-history-controls {\n    width: 100%;\n  }\n\n  .history-view-select,\n  .history-periods-select {\n    flex: 1;\n  }\n\n  .goals-progress-container {\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
